module.exports = __webpack_public_path__ + "img/design2.06605549.svg";